import { ApiBase } from "config";

const baseUrl = `${ApiBase}/api`;
const dropdownUrl = `${ApiBase}/api/dropdown`;

export const endpoints = {
  changeRack: {
    getRackListByMaterialID: `${baseUrl}/Rack/getRacklistbyMaterial`,
    updateRack: `${baseUrl}/Rack/updateRack`,
    getRack: `${dropdownUrl}/getRack`,
  },

  changeSection: {
    getSectionListByMaterialID: `${baseUrl}/Section/getSectionlistbyMaterial`,
    updateSection: `${baseUrl}/Section/updateSection`,
  },

  member: {
    memberList: `${baseUrl}/Member/list`,
    getById: `${baseUrl}/Member`,
    getMemberValues: `${dropdownUrl}/getMember`,
    getMemberStatusValues: `${dropdownUrl}/getMemberStatus`,
    getMemberType: `${dropdownUrl}/getMemberType`,
    update: `${baseUrl}/Member/update`,
    create: `${baseUrl}/Member/create`,
    delete: `${baseUrl}/Member/delete`,
    bulkDelete: `${baseUrl}/Member/delete/bulk`,
    getMemberAllDetail: `${baseUrl}/Member/memberDetail`,
    view: `${baseUrl}/Member/view`,
    generateNoDueCertificate: `${baseUrl}/Member/generateNoDueCertificate`,
    deleteNoDueCertificate: `${baseUrl}/Member/deleteNoDueCertificate`,
    importStudent: `${baseUrl}/Member/importStudent`,
    importStaff: `${baseUrl}/Member/importStaff`,
    umsAutoImportLogs: `${baseUrl}/Member/umsAutoImportLogs`,
    getMemberCardsData: `${baseUrl}/Member/getMemberCardsData`,
  },

  OPAC: {
    getOPACLibrary: `${dropdownUrl}/getOPACLibrary`,
    getMaterialTypeByLibraryID: `${dropdownUrl}/getMaterialTypeByLibraryID`,
    getOPACLanguage: `${dropdownUrl}/getOPACLanguage`,
    getOPACInstitute: `${dropdownUrl}/getOPACInstitute`,
    getOPACDepartmentbyInstituteID: `${dropdownUrl}/getOPACDepartmentbyInstituteID`,
    getBasicSearch: `${baseUrl}/opac/basicSearch`,
    getAdvanceSearch: `${baseUrl}/opac/advanceSearch`,
    getnewArrivals: `${baseUrl}/opac/newArrivals`,
    getSearchMaterialContent: `${baseUrl}/opac/searchMaterialContent`,
    getMemberStatusDetails: `${baseUrl}/opac/getMemberStatusDetails`,
    getMaterialDetails: `${baseUrl}/opac/getMaterialDetails`,
  },

  material: {
    materialList: `${baseUrl}/Material/list`,
    create: `${baseUrl}/Material/create`,
    getById: `${baseUrl}/Material`,
    update: `${baseUrl}/Material/update`,
    delete: `${baseUrl}/Material/delete`,
    view: `${baseUrl}/Material/view`,
    getMaterialAuthorValuesByMaterialID: `${baseUrl}/Material/GetAuthors`,
    getMaterialValues: `${baseUrl}/Material/getMaterial`,
    importMaterial: `${baseUrl}/Material/importMaterial`,
  },

  accession: {
    matAccessionList: `${baseUrl}/MaterialAccessionNo/list`,
    view: `${baseUrl}/MaterialAccessionNo/view`,
    delete: `${baseUrl}/MaterialAccessionNo/delete`,
    create: `${baseUrl}/MaterialAccessionNo/create`,
    update: `${baseUrl}/MaterialAccessionNo/update`,
    updateAccessionNo: `${baseUrl}/MaterialAccessionNo/updateAccessionNo`,
    getById: `${baseUrl}/MaterialAccessionNo`,
    copyAcc: `${baseUrl}/MaterialAccessionNo/copyAcc`,
    nextAccNo: `${baseUrl}/MaterialAccessionNo/nextAccessionNo`,
  },

  accessionAccompanying: {
    accessionAccompanyingList: `${baseUrl}/MaterialAccessionWiseAccompanyingMaterials/list`,
    create: `${baseUrl}/MaterialAccessionWiseAccompanyingMaterials/create`,
    update: `${baseUrl}/MaterialAccessionWiseAccompanyingMaterials/update`,
    delete: `${baseUrl}/MaterialAccessionWiseAccompanyingMaterials/delete`,
  },

  chapter: {
    chapterList: `${baseUrl}/Chapter/list`,
    create: `${baseUrl}/Chapter/create`,
    update: `${baseUrl}/Chapter/update`,
    getById: `${baseUrl}/Chapter`,
  },

  chapterContent: {
    chapterContentList: `${baseUrl}/ChapterContent/list`,
    create: `${baseUrl}/ChapterContent/create`,
    update: `${baseUrl}/ChapterContent/update`,
    delete: `${baseUrl}/ChapterContent/delete`,
  },

  materialAuthor: {
    create: `${baseUrl}/MaterialAuthor/create`,
  },

  publication: {
    list: `${baseUrl}/publication/list`,
    view: `${baseUrl}/publication/view`,
    delete: `${baseUrl}/publication/delete`,
    create: `${baseUrl}/publication/create`,
    update: `${baseUrl}/publication/update`,
    getById: `${baseUrl}/publication`,
    getPublicationValues: `${dropdownUrl}/getPublication`,
  },

  institute: {
    list: `${baseUrl}/institute/list`,
    view: `${baseUrl}/institute/view`,
    delete: `${baseUrl}/institute/delete`,
    create: `${baseUrl}/institute/create`,
    update: `${baseUrl}/institute/update`,
    getById: `${baseUrl}/institute`,
    getInstituteValues: `${dropdownUrl}/getinstitute`,
    getInstituteByUniverisity: `${dropdownUrl}/getInstitutebyUniversityID`,
    getInstituteByLibrary: `${dropdownUrl}/getInstituteByLibraryID`,
  },

  program: {
    list: `${baseUrl}/program/list`,
    view: `${baseUrl}/program/view`,
    delete: `${baseUrl}/program/delete`,
    create: `${baseUrl}/program/create`,
    update: `${baseUrl}/program/update`,
    getById: `${baseUrl}/program`,
    getProgramValues: `${dropdownUrl}/getProgram`,
    getProgramValuesByInstituteDepartment: `${dropdownUrl}/getProgramByInstituteDepartment`,
  },

  university: {
    list: `${baseUrl}/university/list`,
    view: `${baseUrl}/university/view`,
    delete: `${baseUrl}/university/delete`,
    create: `${baseUrl}/university/create`,
    update: `${baseUrl}/university/update`,
    getById: `${baseUrl}/university`,
    getUniversityValues: `${dropdownUrl}/getUniversity`,
  },

  course: {
    list: `${baseUrl}/course/list`,
    view: `${baseUrl}/course/view`,
    delete: `${baseUrl}/course/delete`,
    create: `${baseUrl}/course/create`,
    update: `${baseUrl}/course/update`,
    getById: `${baseUrl}/course`,
    getCourseValues: `${dropdownUrl}/getCourse`,
    getCourseByUniverisity: `${dropdownUrl}/getCoursebyUniversityID`,
  },

  department: {
    list: `${baseUrl}/department/list`,
    view: `${baseUrl}/department/view`,
    delete: `${baseUrl}/department/delete`,
    create: `${baseUrl}/department/create`,
    update: `${baseUrl}/department/update`,
    getById: `${baseUrl}/department`,
    getDepartmentValues: `${dropdownUrl}/getdepartment`,
    getDepartmentValuesWithInstituteCode: `${dropdownUrl}/getDepartmentWithInstituteCode`,
    getDepartmentValuesByInstitute: `${dropdownUrl}/getDepartmentbyInstituteID`,
  },

  specialization: {
    list: `${baseUrl}/specialization/list`,
    view: `${baseUrl}/specialization/view`,
    delete: `${baseUrl}/specialization/delete`,
    create: `${baseUrl}/specialization/create`,
    update: `${baseUrl}/specialization/update`,
    getById: `${baseUrl}/specialization`,
    getSpecializationValues: `${dropdownUrl}/getSpecialization`,
    getSpecializationByCourse: `${dropdownUrl}/getSpecializationbyCourseID`,
  },

  supplier: {
    list: `${baseUrl}/supplier/list`,
    view: `${baseUrl}/supplier/view`,
    delete: `${baseUrl}/supplier/delete`,
    create: `${baseUrl}/supplier/create`,
    update: `${baseUrl}/supplier/update`,
    getById: `${baseUrl}/supplier`,
    getSupplierValues: `${dropdownUrl}/getSupplier`,
  },

  acquisitionMode: {
    list: `${baseUrl}/acquisitionmode/list`,
    view: `${baseUrl}/acquisitionmode/view`,
    delete: `${baseUrl}/acquisitionmode/delete`,
    create: `${baseUrl}/acquisitionmode/create`,
    update: `${baseUrl}/acquisitionmode/update`,
    getById: `${baseUrl}/acquisitionmode`,
    getAcquisitionModeValues: `${dropdownUrl}/getacquisitionmode`,
  },

  biblevel: {
    list: `${baseUrl}/biblevel/list`,
    view: `${baseUrl}/biblevel/view`,
    delete: `${baseUrl}/biblevel/delete`,
    create: `${baseUrl}/biblevel/create`,
    update: `${baseUrl}/biblevel/update`,
    getById: `${baseUrl}/biblevel`,
    getBIBLevelValues: `${dropdownUrl}/getBIBLevel`,
  },

  bindingType: {
    list: `${baseUrl}/bindingType/list`,
    view: `${baseUrl}/bindingType/view`,
    delete: `${baseUrl}/bindingType/delete`,
    create: `${baseUrl}/bindingType/create`,
    update: `${baseUrl}/bindingType/update`,
    getById: `${baseUrl}/bindingType`,
  },

  rack: {
    list: `${baseUrl}/rack/list`,
    view: `${baseUrl}/rack/view`,
    delete: `${baseUrl}/rack/delete`,
    create: `${baseUrl}/rack/create`,
    update: `${baseUrl}/rack/update`,
    getById: `${baseUrl}/rack`,
    getRackValues: `${dropdownUrl}/getrack`,
  },

  section: {
    list: `${baseUrl}/section/list`,
    view: `${baseUrl}/section/view`,
    delete: `${baseUrl}/section/delete`,
    create: `${baseUrl}/section/create`,
    update: `${baseUrl}/section/update`,
    getById: `${baseUrl}/section`,
    getSectionValues: `${dropdownUrl}/getSection`,
  },

  physicalMedium: {
    list: `${baseUrl}/physicalMedium/list`,
    view: `${baseUrl}/physicalMedium/view`,
    delete: `${baseUrl}/physicalMedium/delete`,
    create: `${baseUrl}/physicalMedium/create`,
    update: `${baseUrl}/physicalMedium/update`,
    getById: `${baseUrl}/physicalMedium`,
    getPhysicalMediumValues: `${dropdownUrl}/getphysicalmedium`,
  },

  classification: {
    list: `${baseUrl}/classification/list`,
    view: `${baseUrl}/classification/view`,
    delete: `${baseUrl}/classification/delete`,
    create: `${baseUrl}/classification/create`,
    update: `${baseUrl}/classification/update`,
    getById: `${baseUrl}/classification`,
    getParentClassificationValues: `${dropdownUrl}/getParentClassification`,
  },

  holiday: {
    list: `${baseUrl}/holiday/list`,
    view: `${baseUrl}/holiday/view`,
    delete: `${baseUrl}/holiday/delete`,
    create: `${baseUrl}/holiday/create`,
    update: `${baseUrl}/holiday/update`,
    getById: `${baseUrl}/holiday`,
  },

  memberStatus: {
    list: `${baseUrl}/memberStatus/list`,
    view: `${baseUrl}/memberStatus/view`,
    delete: `${baseUrl}/memberStatus/delete`,
    create: `${baseUrl}/memberStatus/create`,
    update: `${baseUrl}/memberStatus/update`,
    getById: `${baseUrl}/memberStatus`,
    getMemberStatusValues: `${dropdownUrl}/getMemberStatus`,
  },

  materialType: {
    list: `${baseUrl}/materialType/list`,
    view: `${baseUrl}/materialType/view`,
    delete: `${baseUrl}/materialType/delete`,
    create: `${baseUrl}/materialType/create`,
    update: `${baseUrl}/materialType/update`,
    getById: `${baseUrl}/materialType`,
    getMaterialTypeValues: `${dropdownUrl}/getMaterialType`,
  },

  materialStatus: {
    list: `${baseUrl}/materialStatus/list`,
    view: `${baseUrl}/materialStatus/view`,
    delete: `${baseUrl}/materialStatus/delete`,
    create: `${baseUrl}/materialStatus/create`,
    update: `${baseUrl}/materialStatus/update`,
    getById: `${baseUrl}/materialStatus`,
    getMaterialStatusValues: `${dropdownUrl}/getMaterialStatus`,
  },

  author: {
    list: `${baseUrl}/author/list`,
    view: `${baseUrl}/author/view`,
    delete: `${baseUrl}/author/delete`,
    create: `${baseUrl}/author/create`,
    update: `${baseUrl}/author/update`,
    getById: `${baseUrl}/author`,
    getAuthorValues: `${dropdownUrl}/getauthor`,
  },

  language: {
    list: `${baseUrl}/language/list`,
    view: `${baseUrl}/language/view`,
    delete: `${baseUrl}/language/delete`,
    create: `${baseUrl}/language/create`,
    update: `${baseUrl}/language/update`,
    getById: `${baseUrl}/language`,
    getLanguageValues: `${dropdownUrl}/getlanguage`,
  },

  memberType: {
    list: `${baseUrl}/memberType/list`,
    view: `${baseUrl}/memberType/view`,
    delete: `${baseUrl}/memberType/delete`,
    create: `${baseUrl}/memberType/create`,
    update: `${baseUrl}/memberType/update`,
    getById: `${baseUrl}/memberType`,
    getMemberTypeValues: `${dropdownUrl}/getMemberType`,
    checkForMember: `${baseUrl}/memberType/checkForMember`,
  },

  instituteWiseMaterialType: {
    list: `${baseUrl}/institutewisematerialtype/list`,
    view: `${baseUrl}/institutewisematerialtype/view`,
    delete: `${baseUrl}/institutewisematerialtype/delete`,
    create: `${baseUrl}/institutewisematerialtype/create`,
    update: `${baseUrl}/institutewisematerialtype/update`,
    getById: `${baseUrl}/institutewisematerialtype`,
  },

  libraryWiseInstitute: {
    list: `${baseUrl}/libraryWiseInstitute/list`,
    view: `${baseUrl}/libraryWiseInstitute/view`,
    delete: `${baseUrl}/libraryWiseInstitute/delete`,
    create: `${baseUrl}/libraryWiseInstitute/create`,
    update: `${baseUrl}/libraryWiseInstitute/update`,
    getById: `${baseUrl}/libraryWiseInstitute`,
  },

  memberTypeWiseMaterialTypeConfig: {
    list: `${baseUrl}/memberTypeWiseMaterialTypeConfig/list`,
    view: `${baseUrl}/memberTypeWiseMaterialTypeConfig/view`,
    delete: `${baseUrl}/memberTypeWiseMaterialTypeConfig/delete`,
    create: `${baseUrl}/memberTypeWiseMaterialTypeConfig/create`,
    update: `${baseUrl}/memberTypeWiseMaterialTypeConfig/update`,
    getById: `${baseUrl}/memberTypeWiseMaterialTypeConfig`,
    getMemberTypewiseMaterialTypeConfigByLibraryID: `${dropdownUrl}/getMemberTypewiseMaterialTypeConfigByLibraryID`,
  },

  user: {
    list: `${baseUrl}/user/list`,
    view: `${baseUrl}/user/view`,
    delete: `${baseUrl}/user/delete`,
    create: `${baseUrl}/user/create`,
    update: `${baseUrl}/user/update`,
    getById: `${baseUrl}/user`,
    getUserValues: `${dropdownUrl}/getUser`,
    resetPassword: `${baseUrl}/account/resetPassword`,
    forgotPassword: `${baseUrl}/account/forgotPassword`,
    changePassowrd: `${baseUrl}/account/changePassword`,
  },

  roles: {
    list: `${baseUrl}/role/list`,
    view: `${baseUrl}/role/view`,
    delete: `${baseUrl}/role/delete`,
    create: `${baseUrl}/role/create`,
    update: `${baseUrl}/role/update`,
    getById: `${baseUrl}/role`,
    getRolesValues: `${dropdownUrl}/getRoles`,
  },

  rolePermission: {
    getPermissions: `${baseUrl}/rolePermission/getPermissions`,
    updateRolePermissions: `${baseUrl}/rolePermission/updatePermissions`,
  },

  library: {
    list: `${baseUrl}/library/list`,
    view: `${baseUrl}/library/view`,
    delete: `${baseUrl}/library/delete`,
    getById: `${baseUrl}/library`,
    getLibraryValues: `${dropdownUrl}/getLibrary`,
    addLibrary: `${baseUrl}/library/generalSettings`,
    updateGeneralSettings: `${baseUrl}/library/updateGeneralSettings`,
    getGeneralSettings: `${baseUrl}/library/getGeneralSettings`,
    getGeneralSettingsByLibrary: `${baseUrl}/library/getGeneralSettings`,
    updateCirculationSettings: `${baseUrl}/library/updateCirculationSettings`,
    getCirculationSettings: `${baseUrl}/library/getCirculationSettings`,
    updateFineSettings: `${baseUrl}/library/updateFineSettings`,
    getFineSettings: `${baseUrl}/library/getFineSettings`,
    updateHolidaySettings: `${baseUrl}/library/updateHolidaySettings`,
    getHolidaySettings: `${baseUrl}/library/getHolidaySettings`,
    getEmailSettings: `${baseUrl}/library/getEmailSettings`,
    updateEmailSettings: `${baseUrl}/library/updateEmailSettings`,
    getReminderSettings: `${baseUrl}/library/getReminderSettings`,
    updateReminderSettings: `${baseUrl}/library/updateReminderSettings`,
    getMemberCardSettings: `${baseUrl}/library/getMemberCardSettings`,
    updateMemberCardSettings: `${baseUrl}/library/updateMemberCardSettings`,
  },

  issue: {
    list: `${baseUrl}/issue/list`,
    getAccessionDetail: `${baseUrl}/issue/getAccessionDetail`,
    getAccessionHistory: `${baseUrl}/issue/getAccessionHistory`,
    getMemberDetail: `${baseUrl}/issue/getMemberDetail`,
    getIssuedItemDetail: `${baseUrl}/issue/getIssuedItemDetail`,
    getById: `${baseUrl}/issue`,
    view: `${baseUrl}/issue/view`,
    issue: `${baseUrl}/issue/issue`,
    returnissue: `${baseUrl}/issue/return`,
    delete: `${baseUrl}/issue/delete`,
    fine: `${baseUrl}/fine/fine`,
    changeDueDate: `${baseUrl}/issue/getMaterialIssuedList`,
    updateDueDate: `${baseUrl}/issue/updateDueDate`,
    renew: `${baseUrl}/issue/renew`,
    getMemberFineDetail: `${baseUrl}/issue/getMemberFineDetail`,
    quickMaterialUpdate: `${baseUrl}/issue/quick-material-update`,
  },

  entryExit: {
    list: `${baseUrl}/entryexit/list`,
    getById: `${baseUrl}/entryexit`,
    create: `${baseUrl}/entryexit/create`,
    delete: `${baseUrl}/entryexit/delete`,
    view: `${baseUrl}/entryexit/view`,
  },

  fine: {
    list: `${baseUrl}/fine/list`,
    getById: `${baseUrl}/fine`,
    delete: `${baseUrl}/fine/delete`,
    create: `${baseUrl}/fine/create`,
    update: `${baseUrl}/fine/update`,
    view: `${baseUrl}/fine/view`,
    getFinelist: `${baseUrl}/fine/getFinelistbyMemberCode`,
    generateReceipt: `${baseUrl}/fine/generateReceipt`,
    reportsCount: `${baseUrl}/fine/reportsCount`,
  },

  receipt: {
    list: `${baseUrl}/fee/Receipt/list`,
    getById: `${baseUrl}/receipt`,
  },

  dashboard: {
    getVisitors: `${baseUrl}/Dashboard/Visitors`,
    getMaterialTypesCount: `${baseUrl}/Dashboard/MaterialWiseCount`,
    getTitleVolume: `${baseUrl}/Dashboard/getTitleVolume`,
    getCirculation: `${baseUrl}/Dashboard/getCirculation`,
    getProgramCirculation: `${baseUrl}/Dashboard/getProgramCirculation`,
    getDueMaterial: `${baseUrl}/Dashboard/getDueMaterial`,
    getGeneralDashboard: `${baseUrl}/Dashboard/getGeneralDashboard`,
    getMemberTypeChart: `${baseUrl}/Dashboard/getMemberStatisticsChart`,
    getIssuedItemChart: `${baseUrl}/Dashboard/getIssuedItemChart`,
    getMemberWidgets: `${baseUrl}/Dashboard/getMemberStatistics`,
    getVisitorWidgets: `${baseUrl}/Dashboard/getVisitorStatistics`,
    getMaterialWidgets: `${baseUrl}/Dashboard/getMaterialStatistics`,
    getCirculationWidgets: `${baseUrl}/Dashboard/getCirculationStatistics`,
    getYearlyCirculation: `${baseUrl}/Dashboard/getYearlyCirculation`,
    exportYearlyCirculation: `${baseUrl}/Dashboard/exportYearlyCirculation`,
    getMonthlyCirculation: `${baseUrl}/Dashboard/getMonthlyCirculation`,
    exportMonthlyCirculation: `${baseUrl}/Dashboard/exportMonthlyCirculation`,
    getTopFrequentlyUsedBooks: `${baseUrl}/Dashboard/getTopFrequentlyUsedBooks`,
    getMostActiveMembers: `${baseUrl}/Dashboard/getMostActiveMembers`,
    getMemberTypeRanking: `${baseUrl}/Dashboard/getMemberTypeRanking`,
    getMaterialTypeRanking: `${baseUrl}/Dashboard/getMaterialTypeRanking`,
    entryExitSummary: `${baseUrl}/Dashboard/entryExitSummary`,
    entryExitCharts: `${baseUrl}/Dashboard/entryExitCharts`,
    currentlyInside: `${baseUrl}/Dashboard/currentlyInside`,
    entryExitLogs: `${baseUrl}/Dashboard/entryExitLogs`,
    getRecentlyAddedBooks: `${baseUrl}/Dashboard/getRecentlyAddedBooks`,
    getRecentlyAddedBooksSummary: `${baseUrl}/Dashboard/recentlyAddedBooksSummary`,
    exportRecentlyAddedBooks: `${baseUrl}/Reports/recentlyAddedBooksExports`,
  },

  email: {
    list: `${baseUrl}/email/list`,
    sendOverdueEmail: `${baseUrl}/Email/sendOverdueEmail`,
    sendFineReminder: `${baseUrl}/Email/sendFineReminder`,
    sendSelectedOverdueEmail: `${baseUrl}/Email/sendSelectedOverdueEmail`,
  },

  noDueCertificate: {
    noDueMemberDetail: `${baseUrl}/Member/noDueMemberDetail`,
    getMembersForBulkNoDueCertificate: `${baseUrl}/Member/getMembersForBulkNoDueCertificate`,
    bulkGenerateNoDueCertificate: `${baseUrl}/Member/bulkGenerateNoDueCertificate`,
    bulkDownloadNoDueCertificate: `${baseUrl}/Member/bulkDownloadNoDueCertificate`,
  },

  finePolicy: {
    list: `${baseUrl}/finePolicy/list`,
    getById: `${baseUrl}/finePolicy`,
    create: `${baseUrl}/finePolicy/create`,
    update: `${baseUrl}/finePolicy/update`,
    delete: `${baseUrl}/finePolicy/delete`,
    view: `${baseUrl}/finePolicy/view`,
  },

  admissionYear: {
    list: `${baseUrl}/admissionYear/list`,
    view: `${baseUrl}/admissionYear/view`,
    delete: `${baseUrl}/admissionYear/delete`,
    create: `${baseUrl}/admissionYear/create`,
    update: `${baseUrl}/admissionYear/update`,
    getById: `${baseUrl}/admissionYear`,
    getAdmissionYearValues: `${dropdownUrl}/getAdmissionYear`,
  },

  country: {
    list: `${baseUrl}/country/list`,
    view: `${baseUrl}/country/view`,
    delete: `${baseUrl}/country/delete`,
    create: `${baseUrl}/country/create`,
    update: `${baseUrl}/country/update`,
    getById: `${baseUrl}/country`,
    getCountryValues: `${dropdownUrl}/getCountry`,
  },

  memberRenew: {
    getById: `${baseUrl}/MemberRenew/getById`,
    single: `${baseUrl}/MemberRenew/single`,
    list: `${baseUrl}/MemberRenew/list`,
    bulk: `${baseUrl}/MemberRenew/bulk`,
  },

  reservation: {
    list: `${baseUrl}/reservation/list`,
    getById: `${baseUrl}/reservation`,
    view: `${baseUrl}/reservation/view`,
    reserve: `${baseUrl}/reservation/reserve`,
    cancel: `${baseUrl}/reservation/cancel`,
    fulfill: `${baseUrl}/reservation/fulfill`,
    queue: `${baseUrl}/reservation/queue`,
    delete: `${baseUrl}/reservation/delete`,
  },

  resetItem: {
    reset: `${baseUrl}/MaterialAccessionNo/resetItems`,
  },

  resetMember: {
    reset: `${baseUrl}/Member/resetMember`,
  },

  circulationGroup: {
    create: `${baseUrl}/group/create`,
    update: `${baseUrl}/group/update`,
    delete: `${baseUrl}/group/delete`,
    getById: `${baseUrl}/group`,
    view: `${baseUrl}/group/view`,
    list: `${baseUrl}/group/list`,
    comboBox: `${baseUrl}/group/comboBox`,
    memberAdd: `${baseUrl}/group/member/add`,
    memberDelete: `${baseUrl}/group/member/delete`,
    memberList: `${baseUrl}/group/member/list`,
    memberReorder: `${baseUrl}/group/member/reorder`,
    issue: `${baseUrl}/group/issue`,
    issueView: `${baseUrl}/group/issue/view`,
    issueList: `${baseUrl}/group/issue/list`,
    return: `${baseUrl}/group/return`,
    returnView: `${baseUrl}/group/return/view`,
    returnList: `${baseUrl}/group/return/list`,
  },

  stockVerification: {
    create: `${baseUrl}/StockVerification/create`,
    update: `${baseUrl}/StockVerification/update`,
    delete: `${baseUrl}/StockVerification/delete`,
    getById: `${baseUrl}/StockVerification`,
    view: `${baseUrl}/StockVerification/view`,
    list: `${baseUrl}/StockVerification/list`,
    start: `${baseUrl}/StockVerification/start`,
    freezeStatus: `${baseUrl}/StockVerification/freezeStatus`,
    pause: `${baseUrl}/StockVerification/pause`,
    resume: `${baseUrl}/StockVerification/resume`,
    cancel: `${baseUrl}/StockVerification/cancel`,
    finalize: `${baseUrl}/StockVerification/finalize`,
    scan: `${baseUrl}/StockVerification/scan`,
    exceptionsList: `${baseUrl}/StockVerification/exceptions/list`,
    scanLogList: `${baseUrl}/StockVerification/scanLog/list`,
    autoVerifiedList: `${baseUrl}/StockVerification/autoVerified/list`,
    exceptionsResolve: `${baseUrl}/StockVerification/exceptions/resolve`,
    exceptionCirculationDetails: (exceptionID: string | number) =>
      `${baseUrl}/StockVerification/exceptions/circulationDetails/${exceptionID}`,
    exceptionTypeMappingList: `${baseUrl}/StockVerification/exceptionTypeMapping/list`,
    exceptionTypeMappingUpdate: `${baseUrl}/StockVerification/exceptionTypeMapping/update`,
    exceptionTypeList: `${baseUrl}/StockVerification/exceptionType/list`,
    exceptionTypeView: `${baseUrl}/StockVerification/exceptionType/view`,
    exceptionTypeCreate: `${baseUrl}/StockVerification/exceptionType/create`,
    exceptionTypeUpdate: `${baseUrl}/StockVerification/exceptionType/update`,
    exceptionTypeDelete: `${baseUrl}/StockVerification/exceptionType/delete`,
  },

  financialYear: {
    list: `${baseUrl}/FinancialYear/list`,
    getById: `${baseUrl}/FinancialYear`,
    create: `${baseUrl}/FinancialYear/create`,
    update: `${baseUrl}/FinancialYear/update`,
    delete: `${baseUrl}/FinancialYear/delete`,
    setActive: `${baseUrl}/FinancialYear/setActive`,
    getFinancialYearValues: `${dropdownUrl}/getFinancialYear`,
    view: `${baseUrl}/FinancialYear/view`,
  },

  fund: {
    list: `${baseUrl}/Fund/list`,
    getById: `${baseUrl}/Fund`,
    create: `${baseUrl}/Fund/create`,
    update: `${baseUrl}/Fund/update`,
    delete: `${baseUrl}/Fund/delete`,
    getFundValues: `${dropdownUrl}/getFund`,
    view: `${baseUrl}/Fund/view`,
  },

  budgetPlan: {
    list: `${baseUrl}/Budget/list`,
    getById: `${baseUrl}/Budget`,
    getByFinancialYear: `${baseUrl}/Budget/getByFinancialYear`,
    create: `${baseUrl}/Budget/create`,
    update: `${baseUrl}/Budget/update`,
    delete: `${baseUrl}/Budget/delete`,
    approve: `${baseUrl}/Budget/approve`,
    view: `${baseUrl}/Budget/view`,
  },

  fundAllocation: {
    getByBudget: `${baseUrl}/FundAllocation/getByBudget`,
    create: `${baseUrl}/FundAllocation/create`,
    update: `${baseUrl}/FundAllocation/update`,
    delete: `${baseUrl}/FundAllocation/delete`,
    view: `${baseUrl}/FundAllocation/view`,
  },

  incomeSource: {
    list: `${baseUrl}/IncomeSource/list`,
    getById: `${baseUrl}/IncomeSource`,
    create: `${baseUrl}/IncomeSource/create`,
    update: `${baseUrl}/IncomeSource/update`,
    delete: `${baseUrl}/IncomeSource/delete`,
    getIncomeSourceValues: `${dropdownUrl}/getIncomeSource`,
    view: `${baseUrl}/IncomeSource/view`,
  },

  incomeTransaction: {
    list: `${baseUrl}/IncomeTransaction/list`,
    getById: `${baseUrl}/IncomeTransaction`,
    create: `${baseUrl}/IncomeTransaction/create`,
    update: `${baseUrl}/IncomeTransaction/update`,
    delete: `${baseUrl}/IncomeTransaction/delete`,
    view: `${baseUrl}/IncomeTransaction/view`,
  },

  purchaseRecommendation: {
    list: `${baseUrl}/PurchaseRecommendation/list`,
    getById: `${baseUrl}/PurchaseRecommendation`,
    create: `${baseUrl}/PurchaseRecommendation/create`,
    update: `${baseUrl}/PurchaseRecommendation/update`,
    delete: `${baseUrl}/PurchaseRecommendation/delete`,
    approve: `${baseUrl}/PurchaseRecommendation/approve`,
    reject: `${baseUrl}/PurchaseRecommendation/reject`,
    getApprovedForFinancialYear: `${baseUrl}/PurchaseRecommendation/getApprovedForFinancialYear`,
    view: `${baseUrl}/PurchaseRecommendation/view`,
    updateStatus: `${baseUrl}/PurchaseRecommendation/updateStatus`,
    export: `${baseUrl}/  PurchaseRecommendation/export`,
  },

  purchaseOrder: {
    list: `${baseUrl}/PurchaseOrder/list`,
    getById: `${baseUrl}/PurchaseOrder`,
    create: `${baseUrl}/PurchaseOrder/create`,
    update: `${baseUrl}/PurchaseOrder/update`,
    delete: `${baseUrl}/PurchaseOrder/delete`,
    approve: `${baseUrl}/PurchaseOrder/approve`,
    getPurchaseOrderForInvoicingValues: `${dropdownUrl}/getPurchaseOrderForInvoicing`,
    view: `${baseUrl}/PurchaseOrder/view`,
    reject: `${baseUrl}/PurchaseOrder/reject`,
    export: `${baseUrl}/PurchaseOrder/export`,
  },

  invoice: {
    list: `${baseUrl}/Invoice/list`,
    getById: `${baseUrl}/Invoice`,
    create: `${baseUrl}/Invoice/create`,
    update: `${baseUrl}/Invoice/update`,
    delete: `${baseUrl}/Invoice/delete`,
    verify: `${baseUrl}/Invoice/verify`,
    markPaid: `${baseUrl}/Invoice/markPaid`,
    view: `${baseUrl}/Invoice/view`,
    pendingSummary: `${baseUrl}/Invoice/pendingSummary`,
    export: `${baseUrl}/Invoice/export`,
    accessionItems: `${baseUrl}/Invoice/accession-items`,
    accessionBooks: `${baseUrl}/Invoice/accession-books`,
  },

  budgetTransfer: {
    list: `${baseUrl}/BudgetTransfer/list`,
    getById: `${baseUrl}/BudgetTransfer`,
    create: `${baseUrl}/BudgetTransfer/create`,
    update: `${baseUrl}/BudgetTransfer/update`,
    delete: `${baseUrl}/BudgetTransfer/delete`,
    approve: `${baseUrl}/BudgetTransfer/approve`,
    reject: `${baseUrl}/BudgetTransfer/reject`,
    view: `${baseUrl}/BudgetTransfer/view`,
  },

  budgetRevision: {
    list: `${baseUrl}/BudgetRevision/list`,
    getById: `${baseUrl}/BudgetRevision`,
    create: `${baseUrl}/BudgetRevision/create`,
    update: `${baseUrl}/BudgetRevision/update`,
    delete: `${baseUrl}/BudgetRevision/delete`,
    approve: `${baseUrl}/BudgetRevision/approve`,
    reject: `${baseUrl}/BudgetRevision/reject`,
    view: `${baseUrl}/BudgetRevision/view`,
  },

  budgetTransaction: {
    list: `${baseUrl}/BudgetTransaction/list`,
    summary: `${baseUrl}/BudgetTransaction/summary`,
  },

  expenseCategory: {
    list: `${baseUrl}/ExpenseCategory/list`,
    getById: `${baseUrl}/ExpenseCategory`,
    create: `${baseUrl}/ExpenseCategory/create`,
    update: `${baseUrl}/ExpenseCategory/update`,
    delete: `${baseUrl}/ExpenseCategory/delete`,
    getExpenseCategoryValues: `${dropdownUrl}/getExpenseCategory`,
    view: `${baseUrl}/ExpenseCategory/view`,
  },

  otherExpense: {
    list: `${baseUrl}/OtherExpense/list`,
    getById: `${baseUrl}/OtherExpense`,
    create: `${baseUrl}/OtherExpense/create`,
    update: `${baseUrl}/OtherExpense/update`,
    delete: `${baseUrl}/OtherExpense/delete`,
    view: `${baseUrl}/OtherExpense/view`,
  },

  notificationTemplate: {
    list: `${baseUrl}/Notification/list`,
    getById: `${baseUrl}/Notification`,
    create: `${baseUrl}/Notification`,
    update: `${baseUrl}/Notification`,
    delete: `${baseUrl}/Notification`,
    comboBox: `${baseUrl}/Notification/comboBox`,
  },

  notificationConfiguration: {
    list: `${baseUrl}/NotificationConfiguration/list`,
    getById: `${baseUrl}/NotificationConfiguration`,
    create: `${baseUrl}/NotificationConfiguration`,
    update: `${baseUrl}/NotificationConfiguration`,
    delete: `${baseUrl}/NotificationConfiguration`,
  },

  emailCredential: {
    list: `${baseUrl}/EmailCredential/list`,
    getById: `${baseUrl}/EmailCredential`,
    create: `${baseUrl}/EmailCredential`,
    update: `${baseUrl}/EmailCredential`,
    delete: `${baseUrl}/EmailCredential`,
    comboBox: `${baseUrl}/EmailCredential/comboBox`,
    deactivate: (credentialID: string | number) =>
      `${baseUrl}/EmailCredential/${credentialID}/deactivate`,
  },

  smsCredential: {
    list: `${baseUrl}/SmsCredential/list`,
    getById: `${baseUrl}/SmsCredential`,
    create: `${baseUrl}/SmsCredential`,
    update: `${baseUrl}/SmsCredential`,
    delete: `${baseUrl}/SmsCredential`,
    comboBox: `${baseUrl}/SmsCredential/comboBox`,
    deactivate: (credentialID: string | number) =>
      `${baseUrl}/SmsCredential/${credentialID}/deactivate`,
  },

  whatsAppCredential: {
    list: `${baseUrl}/WhatsAppCredential/list`,
    getById: `${baseUrl}/WhatsAppCredential`,
    create: `${baseUrl}/WhatsAppCredential`,
    update: `${baseUrl}/WhatsAppCredential`,
    delete: `${baseUrl}/WhatsAppCredential`,
    comboBox: `${baseUrl}/WhatsAppCredential/comboBox`,
    deactivate: (credentialID: string | number) =>
      `${baseUrl}/WhatsAppCredential/${credentialID}/deactivate`,
  },

  firebaseCredential: {
    list: `${baseUrl}/FirebaseCredential/list`,
    getById: `${baseUrl}/FirebaseCredential`,
    create: `${baseUrl}/FirebaseCredential`,
    update: `${baseUrl}/FirebaseCredential`,
    delete: `${baseUrl}/FirebaseCredential`,
    comboBox: `${baseUrl}/FirebaseCredential/comboBox`,
    deactivate: (credentialID: string | number) =>
      `${baseUrl}/FirebaseCredential/${credentialID}/deactivate`,
  },

  notificationEmailLog: {
    list: `${baseUrl}/EmailLog/list`,
    getById: `${baseUrl}/EmailLog`,
    retry: (emailLogID: string | number) => `${baseUrl}/EmailLog/${emailLogID}/retry`,
  },

  notificationSmsLog: {
    list: `${baseUrl}/SmsLog/list`,
    getById: `${baseUrl}/SmsLog`,
    retry: (smsLogID: string | number) => `${baseUrl}/SmsLog/${smsLogID}/retry`,
  },

  notificationWhatsAppLog: {
    list: `${baseUrl}/WhatsAppLog/list`,
    getById: `${baseUrl}/WhatsAppLog`,
    retry: (whatsAppLogID: string | number) =>
      `${baseUrl}/WhatsAppLog/${whatsAppLogID}/retry`,
  },

  notificationPushLog: {
    list: `${baseUrl}/PushLog/list`,
    getById: `${baseUrl}/PushLog`,
    retry: (pushLogID: string | number) => `${baseUrl}/PushLog/${pushLogID}/retry`,
  },

  notificationPauseConfiguration: {
    list: `${baseUrl}/PauseConfiguration/list`,
    create: `${baseUrl}/PauseConfiguration`,
    delete: (channelType: string | number) =>
      `${baseUrl}/PauseConfiguration/${channelType}`,
  },

  notificationJobExecutionHistory: {
    list: `${baseUrl}/JobExecutionHistory/list`,
  },

  bookTransfer: {
    create: `${baseUrl}/BookTransfer/create`,
    validateAccession: `${baseUrl}/BookTransfer/validateAccession`,
    list: `${baseUrl}/BookTransfer/list`,
    items: (id: string | number) => `${baseUrl}/BookTransfer/items/${id}`,
    getSectionByLibraryID: `${dropdownUrl}/getSectionByLibraryID`,
    getRackByLibraryID: `${dropdownUrl}/getRackByLibraryID`,
    export: "api/Reports/bookTransferExports",
  },

  biometricConfiguration: {
    list: `${baseUrl}/BiometricConfiguration/list`,
    getById: `${baseUrl}/BiometricConfiguration`,
    create: `${baseUrl}/BiometricConfiguration/create`,
    update: `${baseUrl}/BiometricConfiguration/update`,
    delete: `${baseUrl}/BiometricConfiguration/delete`,
  },

  biometricPunchLog: {
    list: `${baseUrl}/BiometricPunchLog/list`,
  },

  biometricSync: {
    syncNow: `${baseUrl}/BiometricSync/sync-now`,
    testApi: `${baseUrl}/BiometricSync/test-api`,
    lastFetchStatus: `${baseUrl}/BiometricSync/last-fetch-status`,
  },

  internalILL: {
    searchAvailableLibraries: (materialId: string | number, currentLibraryId?: string | number) =>
      `${baseUrl}/InternalILL/searchAvailableLibraries/${materialId}${currentLibraryId ? `?currentLibraryId=${currentLibraryId}` : ""}`,
    create: `${baseUrl}/InternalILL/create`,
    accept: `${baseUrl}/InternalILL/accept`,
    reject: `${baseUrl}/InternalILL/reject`,
    dispatchToBorrower: `${baseUrl}/InternalILL/dispatchToBorrower`,
    markReceived: `${baseUrl}/InternalILL/markReceived`,
    dispatchReturn: `${baseUrl}/InternalILL/dispatchReturn`,
    closeLoan: `${baseUrl}/InternalILL/closeLoan`,
    markLost: `${baseUrl}/InternalILL/markLost`,
    receiveReplacement: `${baseUrl}/InternalILL/receiveReplacement`,
    listBorrowing: `${baseUrl}/InternalILL/listBorrowing`,
    listLending: `${baseUrl}/InternalILL/listLending`,
      getById: (id: string | number) => `${baseUrl}/InternalILL/${id}`,
    export: "api/Reports/internalILLExports",
  },
  dataExportField: {
    selectExportColumnsByGroupName: `${baseUrl}/Configuration/CFG_DataExportField/selectExportColumnsByGroupName`,
  },
  genericExport: "api/GenericExport/download",
};
